import { render, staticRenderFns } from "./BankSuggestedInvoiceTable.vue?vue&type=template&id=0e2aec11&scoped=true&"
import script from "./BankSuggestedInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./BankSuggestedInvoiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2aec11",
  null
  
)

export default component.exports